import { supportServiceConnectClient } from "api";

import {
  GetFeatureSettingsRequest,
  GetFeatureSettingsResponse,
  UpdateFeatureSettingsRequest,
  UpdateFeatureSettingsResponse,
} from "@safetyculture/s12-apis-connect-web/s12/inductions/admin/v1/inductions_admin_service_pb";
import { FeatureSettings } from "@safetyculture/s12-apis-connect-web/s12/inductions/type/v1/feature_settings_pb";

import { RequestMetadata } from "api/types";
import { toUUID } from "helpers/s12-helpers";

type InductionsFeatureSettingsParams = {
  organisationID: string;
};

export const getInductionsFeatureSettings = async (
  { organisationID }: InductionsFeatureSettingsParams,
  headers: Record<RequestMetadata, string>,
): Promise<GetFeatureSettingsResponse> => {
  const uuid = toUUID(organisationID);
  const req = new GetFeatureSettingsRequest({ organisationId: uuid });
  return await supportServiceConnectClient.getInductionsFeatureSettings(req, {
    headers,
  });
};

type UpdateInductionsFeatureSettingsParams = {
  organisationID: string;
  contractorBundleEnabled: boolean;
};

export const updateInductionsFeatureSettings = async (
  {
    organisationID,
    contractorBundleEnabled,
  }: UpdateInductionsFeatureSettingsParams,
  headers: Record<RequestMetadata, string>,
): Promise<UpdateFeatureSettingsResponse> => {
  const uuid = toUUID(organisationID);
  const featureSettings = new FeatureSettings({ contractorBundleEnabled });
  const req = new UpdateFeatureSettingsRequest({
    organisationId: uuid,
    adminFeatureSettings: featureSettings,
  });
  return await supportServiceConnectClient.updateInductionsFeatureSettings(
    req,
    {
      headers,
    },
  );
};
